import { BitrixVue } from 'ui.vue';
import '../configBlock/configBlockRow.js';

BitrixVue.component('RadioGroup', {
	data() {
		return {
			radioValue:
				this.selected && this.options.indexOf(this.selected) !== -1
					? this.options.indexOf(this.selected)
					: this.selected !== undefined && !isNaN(this.selected + 1)
					? this.selected
					: '',
		};
	},
	props: ['state', 'name', 'options', 'selected'],
	mounted() {
		this.$emit('selectedValue', this.radioValue);
	},
	methods: {
		setActive(value) {
			this.radioValue = value;
			this.$emit('selectedValue', this.radioValue);
		},
	},
	template: `
<ConfigBlockRow>
	<label class="custom-radio" v-for="(radio, index) of this.options">
		<input class="custom-radio__input" type="radio" :name="this.name"
			:value="radio.value !== undefined ? radio.value : index" v-model="radioValue"
			@change="setActive(radio.value !== undefined ? radio.value : index)"
			:checked="radioValue === radio.label || radioValue === radio.value ? true : false">
		<span class="custom-radio__circle"></span>
		<span class="custom-radio__title">{{radio.label ? radio.label : radio}}</span>
		<span class="custom-checkbox__text" v-if="radio.text">{{radio.text}}</span>
	</label>
</ConfigBlockRow>
<!-- <label class="custom-radio">
	<ui-radio-group :name="this.name" :options="this.options" v-model="radioValue" class="custom-radio"
		@change="$emit('selectedValue',radioValue)">{{this.text}}</ui-radio-group>
	<span class="custom-checkbox__text" v-for="option of this.options" v-if="option.text">{{option.text}}</span>
</label> -->

`,
});
